export enum BlogTypeValues {
  Blog = "Blog",
  Vlog = "Vlog",
  Tip = "Tip",
  Information = "Information",
}
